<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding shadow mobile">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>

      &nbsp;
      <h2 class="heading">International Mobile Recharge</h2>
      <div class="row no-gutters">
        <div class="col-12">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="add-balance">
                <div class="ctl-inner">
                  <span class="crtl icon-add_money_1"></span>
                </div>
                <div class="">
                  <span class="bal-txt">Balance</span>
                  <span class="bal_amount">{{UsertBal.currentBalance}} {{UsertBal.currency}}</span>
                </div>
              </div>
            </div>
            <div class="col-12 form-padding">
              <form class="example-form" (ngSubmit)="openDialog(payIntMobileForm.value)"
                    [formGroup]="payIntMobileForm">
                <div class="row no-gutters">
                  <div class="col-12">
                    <mat-radio-group class="example-radio-group" formControlName="PaymentModeCode">
                      <mat-radio-button *ngFor="let x of OptionList?.addmoneyservice" [value]="x.code">{{x.name}}</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div class="col-12">
                    <mat-form-field>
                      <mat-label>Select Country</mat-label>
                      <mat-select formControlName="ISD" matTooltip="Select Country" autocomplete="off"
                                  
                                  required>
                        <mat-form-field>
                          <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
                        </mat-form-field>
                        <mat-option *ngFor="let d of filterCountry(); let i=index" [value]="d.iso_code" (click)="getopertorbyCountry(d)">
                          {{d?.name}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && f.ISD?.errors?.required">
                        Select Country
                      </mat-error>
                    </mat-form-field>

                  </div>

                  <div class="col-12" *ngIf="operatorsList">
                    <mat-form-field class="example-full-width">
                      <mat-label>Select Operator</mat-label>
                      <mat-select formControlName="OperatorName" required>
                        <mat-option [value]="d?.id" *ngFor="let d of operatorsList; let i=index" (click)="GetdtoneproductList(d)">
                          {{d?.name}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && f.OperatorName?.errors?.required">
                        Select Operator
                      </mat-error>
                    </mat-form-field>
                  </div>



                  <div class="col-12">
                    <mat-form-field *ngIf="productList">
                      <mat-label>Select Product</mat-label>
                      <mat-select formControlName="Channel" required>
                        <mat-option [value]="d?.id" (click)="selectedProduct(d)" *ngFor="let d of productList; let i=index">
                          {{d?.name}} -- {{d?.usdsourceamount}} {{d?.usdsourceunit}}
                        </mat-option>

                      </mat-select>
                      <mat-error *ngIf="submitted && f.Channel?.errors?.required">
                        Select Product
                      </mat-error>
                    </mat-form-field>

                    <div class="row payable-amount justify-content-around align-items-center mb-4 mt-0">
                      <div class="col-6" *ngIf="amt">

                        <p>Fee({{UsertBal.currency}})</p>
                        <p>{{commissionFee|number}}</p>
                      </div>
                      <div class="col-6 text-right" *ngIf="amt">
                        <p>Net Payable({{UsertBal.currency}})</p>
                        <p>{{commissionTotal|number}}</p>
                      </div>
                    </div>

                    <!--<div class="row payable-amount justify-content-around align-items-center mb-4 mt-0">
                      <div class="col-6" *ngIf="amt">
                        <p *ngIf="UsertBal.currency == 'USD' && show == 1 || show == 3"><b>Fee({{UsertBal.currency}})</b></p>
                        <p *ngIf="UsertBal.currency == 'USD' && show == 1 || show == 3">{{commissionFee|number}}
                      </div>
                      <div class="col-6 text-right" *ngIf="amt">
                        <p *ngIf="UsertBal.currency == 'USD' && show == 2"><b>Net Amount In USD</b></p>
                        <p *ngIf="UsertBal.currency == 'USD' && show == 1 || show == 3"><b>Net Payable({{UsertBal.currency}})</b></p>
                        <p *ngIf="amt">{{commissionTotal|number}}</p>
                      </div>
                    </div>-->
                  </div>


                  <div class="col-12" *ngIf="productList">
                    <mat-form-field class="example-full-width input-tel">
                      <input type="tel" matInput
                             placeholder="Enter Mobile No. with country code (eg:2550574546568)"
                             formControlName="mobileno" NumberOnly maxlength="20" required>
                      <mat-error *ngIf="submitted && f.mobileno?.errors?.required">
                        Enter Mobile No. with country code (eg:2550574546568)
                      </mat-error>
                    </mat-form-field>
                  </div>


                  
                  <div class="col-12">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Beneficiary Name"
                             formControlName="BeneficiaryName" maxlength="20" />
                      <mat-error *ngIf="f.BeneficiaryName?.errors?.pattern">
                        Enter Alphabet character
                      </mat-error>


                    </mat-form-field>
                  </div>
                  <div class="col-12" >
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Account Description (eg:Kofi's account)"
                             maxlength="200" formControlName="Comment" />

                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <button type="submit" class="primary-btn">
                      SUBMIT
                    </button>
                  </div>
                  
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>
      </div>
    </div>
    


  </div>

</fieldset>
